module.exports = __webpack_public_path__ + "img/logo-full_milano.435546ed.png";